import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import CodeBlock from "./CodeBlock";
import { etapas, refContent } from "../data/guiaAssemblyData";

const preStyle = {
  background: "#0d1117",
  color: "#a8c0e0",
  borderRadius: "6px",
  padding: "10px 14px",
  fontFamily: "var(--guia-mono)",
  fontSize: "12px",
  margin: "8px 0 0",
  overflowX: "auto",
  border: "1px solid var(--bs-border-color)",
  lineHeight: "1.65",
  textAlign: "left",
};

function EtapaCard({ etapa, onOpen }) {
  return (
    <div
      className={`guia-etapa ${etapa.color}`}
      onClick={() => onOpen({ title: etapa.num, subtitle: etapa.title, info: etapa.info })}
    >
      <div className="guia-etapa-num">{"// "}{etapa.num}</div>
      <div className="guia-etapa-title">{etapa.title}</div>
      <div className="guia-etapa-desc">
        {etapa.tags.map((tag) => <span key={tag}>{tag}</span>)}
      </div>
    </div>
  );
}

function ExemplosColuna({ exemplos, onOpen }) {
  return (
    <div className="guia-exemplos">
      {exemplos.map((ex) => (
        <div
          key={ex.name}
          className="guia-exemplo"
          onClick={() => onOpen({ title: ex.name, subtitle: ex.desc, code: ex.code })}
        >
          <div className="guia-exemplo-icon">&gt;_</div>
          <div>
            <div className="guia-exemplo-name">{ex.name}</div>
            <div className="guia-exemplo-desc">{ex.desc}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

function GuiaModal({ modal, onClose, preStyle }) {
  return (
    <div className="guia-modal-bg" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="guia-modal">
        <button className="guia-modal-close" onClick={onClose}>✕</button>
        <h2>{modal.title}</h2>
        <div className="guia-modal-subtitle">{modal.subtitle}</div>
        {modal.info ? (
          <dl style={{ margin: 0 }}>
            {modal.info.map(({ tag, exp, code }) => (
              <div key={tag} style={{ marginBottom: "20px" }}>
                <dt style={{ fontFamily: "var(--guia-mono)", fontSize: "13px", color: "var(--bs-emphasis-color)", marginBottom: "4px" }}>{tag}</dt>
                <dd style={{ margin: 0, fontSize: "13px", color: "var(--bs-secondary-color)", lineHeight: "1.6" }}>{exp}</dd>
                {code && <pre style={preStyle}>{code}</pre>}
              </div>
            ))}
          </dl>
        ) : (
          <CodeBlock code={modal.code} />
        )}
      </div>
    </div>
  );
}

function GuiaAssemblyARM64() {
  const [modal, setModal] = useState(null);

  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") setModal(null); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  const openModal = ({ title, subtitle, code = null, info = null }) =>
    setModal({ title, subtitle, code, info });

  return (
    <Container className="guia-asm mb-5 transicao" data-bs-theme="dark">
      <h1>ASSEMBLY ARM64</h1>
      <hr />
      <p className="text-muted" style={{ fontFamily: "var(--guia-mono)", fontSize: "13px" }}>
        Prof. Mario Pego · Raspberry Pi · Clique em qualquer card para ver o código
      </p>

      <div className="guia-legend">
        <div className="guia-legend-item">
          <div className="guia-legend-dot" style={{ background: "#1ead8a" }} />
          Fundamentos (E1–E4)
        </div>
        <div className="guia-legend-item">
          <div className="guia-legend-dot" style={{ background: "#8b7cf6" }} />
          Funções e Aritmética (E5–E6)
        </div>
        <div className="guia-legend-item">
          <div className="guia-legend-dot" style={{ background: "#f0a832" }} />
          Ponto Flutuante (E7)
        </div>
        <div className="guia-legend-item">
          <div className="guia-legend-dot" style={{ background: "#e86060" }} />
          Controle de Fluxo (E8–E9)
        </div>
      </div>

      <div className="guia-grid">
        {etapas.map((etapa) => (
          <React.Fragment key={etapa.num}>
            <EtapaCard etapa={etapa} onOpen={openModal} />
            <ExemplosColuna exemplos={etapa.exemplos} onOpen={openModal} />
          </React.Fragment>
        ))}
      </div>

      <div
        className="guia-ref-card"
        onClick={() => openModal({
          title: "Referência rápida AArch64",
          subtitle: "Registradores · Syscalls · Diretivas · Instruções",
          code: refContent,
        })}
      >
        <div className="guia-ref-card-icon">§</div>
        <div className="guia-ref-card-text">
          <h3>Referência Rápida AArch64</h3>
          <p>Registradores · Syscalls · Diretivas · Instruções principais</p>
        </div>
      </div>

      {modal && (
        <GuiaModal modal={modal} onClose={() => setModal(null)} preStyle={preStyle} />
      )}
    </Container>
  );
}

export default GuiaAssemblyARM64;
